import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../../shared/services/configuration.service';
import { I18N_APP_ID } from '../injection-tokens';

@Injectable()
export class CustomTranslateLoader implements TranslateLoader {

  constructor(
    private httpClient: HttpClient,
    private configurationService: ConfigurationService,
    @Inject(I18N_APP_ID) private applicationId: string
  ) {}

  getTranslation(lang: string): Observable<any> {
    const apiAddress = `${this.configurationService.configuration.api.translate}/${this.applicationId}/${lang}/plain`;
    return this.httpClient.get(apiAddress)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(_ => {
          return this.httpClient.get(`/assets/i18n/it.json`);
        }),
      );
  }
}
